import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
import { Popup, LoadPanel } from 'devextreme-react';
import { Position, ToolbarItem } from 'devextreme-react/popup';
import PdfViewer from '../../../../components/pdfViewer/pdfViewer';
import PopupSignature, { PopupSignatureHandle } from '../../../../components/popup-signature/popupSignature';
import useApiConfiguration from '../../../../apiConfig';
import { RapportiniApi } from '../../../../data';

type Props = {
    onHide: () => void;
}

export type PopupReportHandle = {
    show: (idRapportino: number, isFirmato: boolean) => void;
}

type State = {
    idRapportino: number;
    isFirmato: boolean;
    visible: boolean;
}

const PopupReport: React.ForwardRefRenderFunction<PopupReportHandle, Props> = (props, ref) => {
    const apiConfiguration = useApiConfiguration();
    const signatureRef = useRef<PopupSignatureHandle>(null);
    const apiRapportini = new RapportiniApi(apiConfiguration);

    const [pdfBlob, setPdfBlob] = useState<Blob>();
    const [state, setState] = useState<State>({ idRapportino: 0, isFirmato: true, visible: false });
    const [loading, setLoading] = useState(false);

    function hideInfo() {
        setState({ idRapportino: 0, isFirmato: true, visible: false });
        props.onHide();
    }

    async function fetchAndSetPdf(idRapportino: number, isFirmato: boolean) {
        setLoading(true);

        try {
            const response = await apiRapportini.generaRapportinoById({ idRapportino: idRapportino });
            if (response?.base64) {
                setState({
                    idRapportino: idRapportino,
                    isFirmato: isFirmato,
                    visible: true
                });

                const fileContent = atob(response.base64);
                const byteArray = new Uint8Array(fileContent.length);
                for (let i = 0; i < fileContent.length; i++)
                    byteArray[i] = fileContent.charCodeAt(i);

                const mimeType = "application/pdf";
                const fileBlob = new Blob([byteArray], { type: mimeType });

                setPdfBlob(fileBlob);
            }
        } finally {
            setLoading(false);
        }
    };

    useImperativeHandle(ref, () => ({
        show(idRapportino, isFirmato) {
            if (idRapportino != 0)
                setState({ idRapportino: idRapportino, isFirmato: isFirmato, visible: true });
            // if (idRapportino != 0)
            //     fetchAndSetPdf(idRapportino, isFirmato);
        }
    }));

    useEffect(() => {
        if (!state.visible) return;

        const fecthPdf = async () => {
            setLoading(true);

            try {
                const response = await apiRapportini.generaRapportinoById({ idRapportino: state.idRapportino });
                if (response?.base64) {
                    const fileContent = atob(response.base64);
                    const byteArray = new Uint8Array(fileContent.length);
                    for (let i = 0; i < fileContent.length; i++)
                        byteArray[i] = fileContent.charCodeAt(i);

                    const mimeType = "application/pdf";
                    const fileBlob = new Blob([byteArray], { type: mimeType });

                    setPdfBlob(fileBlob);
                }
            } finally {
                setLoading(false);
            }
        };

        fecthPdf();
    }, [state.visible]);

    function extractBase64(dataURL: string) {
        const base64Index = dataURL.indexOf('base64,');
        if (base64Index === -1) return null;
        return dataURL.substring(base64Index + 7);
    };

    async function signatureSubmitDataURL(dataURL: string) {
        setLoading(true);

        try {
            await apiRapportini.firmaRapportino({
                rapportinoFileDTO: {
                    id: state.idRapportino,
                    base64: extractBase64(dataURL)
                }
            });

            await fetchAndSetPdf(state.idRapportino, true);
        } catch (error) {
            console.error('Error during signature submission:', error);
        }

        setLoading(false);
    }

    return (
        <Popup
            visible={state.visible}
            dragEnabled={false}
            hideOnOutsideClick={false}
            showCloseButton={false}
            showTitle={false}
            fullScreen={true}
            container=".dx-viewport"
        >
            <Position at="center" my="center" of="" collision="fit" />

            {!state.isFirmato &&
                <ToolbarItem
                    widget='dxButton'
                    toolbar='bottom'
                    location='center'
                    options={{
                        text: "Firma",
                        onClick: signatureRef.current?.show
                    }}
                />
            }

            <ToolbarItem
                widget='dxButton'
                toolbar='bottom'
                location='center'
                options={{
                    text: "Chiudi",
                    onClick: hideInfo
                }}
            />

            {loading && <LoadPanel style={{ zIndex: 9999 }} shading={true} shadingColor="rgba(0, 0, 0, 0.4)" position={'center'} visible={true} />}
            {!loading && <PdfViewer pdfBlob={pdfBlob} />}

            <PopupSignature ref={signatureRef} onSubmitDataURL={signatureSubmitDataURL} />
        </Popup>
    )
}

export default React.forwardRef(PopupReport);